import React, { useState } from "react";
import useAuth from "./../../hooks/useAuth";

import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

import { OPENAPI } from "./../../utils/apiCalls";
import { Translate } from "react-auto-translate";
import Common from "./common";
import ResponseDiv from "./Response";
import { useSelector } from "react-redux";

function Inner({ data = [] }) {
  const { state } = useLocation();
  const { NotificationsToasts = null } = useSelector((state) => state.user);
  const [blogimage, setBlogImage] = useState(state?.v.image);
  const { getLoggedObject } = useAuth();
  const [loading, setLoading] = useState(false);
  const [brandname, setBrandName] = useState(data?.data[0]?.textfield || "");
  const [description, setDescription] = useState(
    data?.data[1]?.textfield || ""
  );

  const [language, setLanguage] = useState("English");
  const [variant, setVariant] = useState(1);
  const [tone, setTone] = useState("Formal");
  const [creativity, setCreativity] = useState("0.75");
  const [responseAI, setResponseAI] = useState([]);
  const [type, setType] = useState("website_headlines");

  const handleDropdownChange = (selectedValue) => {
    setLanguage(selectedValue);
  };
  const handleDropdownVariant = (selectedValue) => {
    setVariant(selectedValue);
  };
  const handleDropdownTone = (selectedValue) => {
    setTone(selectedValue);
  };
  const handleDropdownCreativity = (selectedValue) => {
    setCreativity(selectedValue);
  };
  const do_make_action = async () => {
    if (brandname == "") {
      toast.error(NotificationsToasts?.enter_product_name?.notification);
      return;
    }
    if (description == "") {
      toast.error(NotificationsToasts?.enter_product_description?.notification);
      return;
    }
    setLoading(true);
    const user_token = getLoggedObject()?.token;
    const max_tokens = 10;
    const temperature = creativity;
    const content_submit =
      "Write a Website headlines in (" +
      language +
      ") where product/brand name is " +
      brandname +
      " AND description is " +
      description +
      " ";
    const payload = [
      { role: "user", content: content_submit },
      {
        role: "system",
        content:
          "system should provide response in  " +
          variant +
          " diffrent variants",
      },
      {
        role: "system",
        content: "Response should be in (" + language + ") language",
      },
      { role: "system", content: `You should use a ${tone} tone.` },
    ];
    // console.log(payload);
    // return;
    const response_ai = await OPENAPI(
      payload,
      max_tokens,
      temperature,
      user_token
    );
    setLoading(false);
    if (response_ai == "error") {
      toast.error(NotificationsToasts?.error_while_connecting?.notification);
      return;
    }
    if (response_ai == "ntoken") {
      toast.error(NotificationsToasts?.account_limit_reached?.notification);
      return;
    }
    const final_response = response_ai.choices[0].message.content;
    const lines = final_response.split("\n");
    setResponseAI((prevResponse) => [...prevResponse, ...lines]);
    // setResponseAI(lines)
  };

  return (
    <>
      <div className="container-wrappe">
        <div className="main-layout">
          <section className="tool-panel">
            <div className="row">
              <div className="col-md-4">
                <div className="card">
                  <div className="card-body">
                    <section className="tool-header">
                      <div>
                        <div className="svgIcon">
                          <img src={blogimage} />
                        </div>
                        <div>
                          <h2>{data?.tool_title}</h2>
                          <p>{data?.tool_description}</p>
                        </div>
                      </div>
                      <div className="planStatus">
                        <div>
                          <div>
                            <strong>free plan </strong>{" "}
                          </div>
                          <div>
                            <div className="progress">
                              <div
                                role="progressbar"
                                className="progress-bar"
                                aria-valuenow={8}
                                aria-valuemin={0}
                                aria-valuemax={100}
                                style={{ width: "8%" }}
                              />
                            </div>{" "}
                          </div>
                          <div className="labelTxt">
                            <strong> 115 </strong>of 1500 words used
                          </div>
                        </div>
                        <div>
                          <button
                            type="button"
                            className="btn btn-outline-primary btn-sm"
                          >
                            <Translate>Upgrade</Translate>
                          </button>
                        </div>
                      </div>
                    </section>
                    <div className="mb-3">
                      <label className="form-label" htmlFor="brandName">
                        <Translate>Product/Brand Name</Translate>
                      </label>
                      <input
                        required=""
                        name="productName"
                        placeholder={
                          data?.data?.length > 0 && data?.data[0]?.placeholder
                        }
                        type="text"
                        id="brandName"
                        className="form-control"
                        value={brandname}
                        onChange={(e) => setBrandName(e.target.value)}
                      />
                    </div>
                    <div className="mt-3 mb-3">
                      <label className="form-label" htmlFor="productFeatures">
                        <Translate> Product Description </Translate>
                      </label>{" "}
                      {/* <span className="float-right text-muted in-text">
                        0/300
                      </span> */}
                      <textarea
                        maxLength={300}
                        placeholder={
                          data?.data?.length > 0 && data?.data[1]?.placeholder
                        }
                        name="productFeatures"
                        required=""
                        id="productFeatures"
                        className="form-control"
                        style={{ height: 150 }}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </div>

                    <Common
                      onSelectionChange={handleDropdownChange}
                      onSelectionVariant={handleDropdownVariant}
                      onSelectionTone={handleDropdownTone}
                      onSelectionCreativity={handleDropdownCreativity}
                    />

                    <button
                      disabled={loading}
                      className="mt-3 w-100 btn btn-primary"
                      onClick={() => do_make_action()}
                    >
                      {loading ? (
                        <div className="flex">
                          <span>Loading...</span>
                        </div>
                      ) : (
                        <Translate>Generate content</Translate>
                      )}
                    </button>
                  </div>
                </div>
                {/* <button type="button" className="exampleData btn btn-link">
                    Add example data
                </button> */}
              </div>
              <div className="ai-board col-md-8 col">
                <ResponseDiv
                  loading={loading}
                  responseAI={responseAI}
                  contentCategory={type}
                />
              </div>
            </div>
          </section>
        </div>
        <div
          style={{
            position: "fixed",
            zIndex: 9999,
            inset: 16,
            pointerEvents: "none",
          }}
        />
      </div>
    </>
  );
}

export default Inner;
